import {
  CardRendererResponseBody,
  CheckboxesRendererResponseBody,
  CheckboxRendererResponseBody,
  ChipsRendererResponseBody,
  DateRangeRendererResponseBody,
  DateRendererResponseBody,
  DividerRendererResponseBody,
  EmailRendererResponseBody,
  NumberRendererResponseBody,
  PhoneRendererResponseBody,
  RowRendererResponseBody,
  SelectRendererResponseBody,
  SwitchRendererResponseBody,
  TextRendererResponseBody,
  SliderRendererResponseBody,
  DateTimeRendererResponseBody,
  MoneyRendererResponseBody,
  PasswordRendererResponseBody,
} from './modelSchema';

export type RendererProps =
  | CardRendererResponseBody
  | RowRendererResponseBody
  | NumberRendererResponseBody
  | TextRendererResponseBody
  | PasswordRendererResponseBody
  | SelectRendererResponseBody
  | ChipsRendererResponseBody
  | CheckboxRendererResponseBody
  | CheckboxesRendererResponseBody
  | SwitchRendererResponseBody
  | SliderRendererResponseBody
  | DateRendererResponseBody
  | DateRangeRendererResponseBody
  | PhoneRendererResponseBody
  | EmailRendererResponseBody
  | DividerRendererResponseBody
  | DateTimeRendererResponseBody
  | MoneyRendererResponseBody;
